import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["kind", "month", "quarter", "year", "custom"];

  connect() {
    this.change();
  }

  change() {
    const selected = this.kindTarget.value;

    this.monthTarget.classList.toggle("hidden", selected !== "month");
    this.quarterTarget.classList.toggle("hidden", selected !== "quarter");
    this.yearTarget.classList.toggle("hidden", selected !== "year");
    this.customTarget.classList.toggle("hidden", selected !== "custom");
  }
}
